module.exports = __webpack_public_path__ + "img/sk.312dcf9.svg";